export const formatTraumaScore = (traumaScore: number) => Math.round(traumaScore) || 7;
